import _ from "lodash";
import { DebugEx } from "@Utils/DebugEx";
import { IWidgetClassParent } from '@UI/Widgets/IWidgetClassParent';
// ----------------------------------------------------------------------------------------------------------
export class DashboardManagerParent {
    // --------------------------------------------------------------------------------------------
    private static _instances: { [key: string]: DashboardManagerParent } = {};
    public static GetInstance(nodeKey: string): DashboardManagerParent { return (_.has(this._instances, nodeKey)) ? this._instances[nodeKey] : null; }
    // --------------------------------------------------------------------------------------------
    public Info: IWidgetClassParent;
    constructor(nodeKey: string, info: IWidgetClassParent) {
        // Add this reference to the dictionary
        DashboardManagerParent._instances[nodeKey] = this;
        this.Info = info;
    }
    // --------------------------------------------------------------------------------------------
    public static GetDefaultInfo(): IWidgetClassParent {
        return new IWidgetClassParent((key, d) => { DebugEx.TraceWarning("Someone using widget without correct class parent") }, () => false);
    }
}
// ----------------------------------------------------------------------------------------------------------